import dayjs, { Dayjs } from "dayjs";
import i18next from "i18next";

export interface Calendar {
  id: string;
  label: string;
  startDate: Dayjs;
  endDate: Dayjs;
  value: string;
}

export const listCalendar: Calendar[] = [
  {
    id: "today",
    label: i18next.t("transaction:today"),
    startDate: dayjs(),
    endDate: dayjs(),
    value: "today",
  },
  {
    id: "3day",
    label: i18next.t("transaction:3day"),
    startDate: dayjs().subtract(3, "days"),
    endDate: dayjs(),
    value: "3day",
  },
  {
    id: "7day",
    label: i18next.t("transaction:7day"),
    startDate: dayjs().subtract(7, "days"),
    endDate: dayjs(),
    value: "7day",
  },
  {
    id: "month",
    label: i18next.t("transaction:month"),
    startDate: dayjs().subtract(30, "days"),
    endDate: dayjs(),
    value: "month",
  },
];
